import { render, staticRenderFns } from "./layout-404.vue?vue&type=template&id=0858f4db&scoped=true"
import script from "./layout-404.vue?vue&type=script&lang=js"
export * from "./layout-404.vue?vue&type=script&lang=js"
import style0 from "./layout-404.vue?vue&type=style&index=0&id=0858f4db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0858f4db",
  null
  
)

export default component.exports